export let ScrollAreaViewportCssVars = /*#__PURE__*/function (ScrollAreaViewportCssVars) {
  /**
   * The distance from the horizontal start edge in pixels.
   * @type {number}
   */
  ScrollAreaViewportCssVars["scrollAreaOverflowXStart"] = "--scroll-area-overflow-x-start";
  /**
   * The distance from the horizontal end edge in pixels.
   * @type {number}
   */
  ScrollAreaViewportCssVars["scrollAreaOverflowXEnd"] = "--scroll-area-overflow-x-end";
  /**
   * The distance from the vertical start edge in pixels.
   * @type {number}
   */
  ScrollAreaViewportCssVars["scrollAreaOverflowYStart"] = "--scroll-area-overflow-y-start";
  /**
   * The distance from the vertical end edge in pixels.
   * @type {number}
   */
  ScrollAreaViewportCssVars["scrollAreaOverflowYEnd"] = "--scroll-area-overflow-y-end";
  return ScrollAreaViewportCssVars;
}({});